import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
} from '@nextui-org/react';

interface CreateExperimentModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreateExperimentModal({
  isOpen,
  onClose,
}: CreateExperimentModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" className="text-sm">
      <ModalContent>
        <ModalHeader>
          <h2 className="text-xl">Create experiment</h2>
          {/* <p className="text-gray-500 text-sm">Evaluate and compare prompts</p> */}
        </ModalHeader>
        <ModalBody className="space-y-6">
          <div>
            <h3 className="mb-2">Tasks</h3>
            <Select label="Select AI model" size="sm">
              <SelectItem key="gpt4">GPT-4</SelectItem>
              <SelectItem key="gpt35">GPT-3.5</SelectItem>
              <SelectItem key="claude">Claude</SelectItem>
            </Select>
            {/* <p className="text-sm text-gray-500 mt-1">
              Each task will result in a separate experiment
            </p> */}
          </div>

          <div>
            <h3 className="mb-2">Dataset</h3>
            <Select label="Select a dataset" size="sm">
              <SelectItem key="1">Dataset 1</SelectItem>
            </Select>
          </div>

          <div>
            <h3 className="mb-2">Scorers</h3>
            <Select label="Select scorers" size="sm">
              <SelectItem key="1">Scorer 1</SelectItem>
            </Select>
          </div>

          {/* <Button size="sm" variant="light" className="w-full justify-start">
            Advanced
          </Button> */}
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onClose}>
            Cancel
          </Button>
          <Button color="primary">Create</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
